export class FleetCostTable {
  fleet: string;
  averageDelayCost: number;
  averageDelayMinutes: number;
  delayCostPerMinute: number;
  divCost: number;
  atbCost: number;
  rtoCost: number;
  ifsdCost: number;
  emerCost: number;
  pdisCost: number;
  oosEventCost: number;
  wdlCost: number;
  rdlCost: number;
  unschedCost: number;
  bfsCost: number;
  otherRmvlCost: number;
  lowTsiCost: number;
  nffCost: number;
  oosDirectCost: number;
  oosIndirectCost: number;
}
